/**
 * @file Helpers for DashboardContent component
 */

import { extractTitle } from '../../hooks/elasticSearch/useEsSmartViewQuery/helpers';
import { FormattedData, FormattedDataArgs } from '../../models/dashboard';
import { getSmartViewsSmartViewUrl } from '../../routes/urls/smartViews';

/**
 * Used for data formatting
 * in order to properly display kpi components
 *
 * @param args              Args passed to function
 * @param args.dashboardKpi Data from server
 * @param args.hotelId      Hotel id
 * @param args.isTablet     Whether the device is a tablet
 * @returns                 Formatted dashboard data
 */
export const getFormattedData = ({
  dashboardKpi,
  hotelId,
  isTablet,
}: FormattedDataArgs): FormattedData => {
  const dataFormatted: FormattedData = {
    CONCIERGE: [],
    REQUEST: [],
    TASK: [],
  };

  dashboardKpi.forEach(kpi => {
    const { dashboardKpiType, title, id, relatedSearchQueryId } =
      kpi.searchQuery;
    if (dashboardKpiType === null || dashboardKpiType === undefined) {
      return;
    }
    dataFormatted[dashboardKpiType].push({
      amount: kpi.searchInfo.total,
      label: extractTitle(title),
      url: getSmartViewsSmartViewUrl(
        hotelId,
        relatedSearchQueryId ?? id,
        isTablet,
      ),
    });
  });

  return dataFormatted;
};
